"use client";

import { useState, useEffect } from "react";

export default function StickyCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const whatsappUrl =
    "https://wa.me/447716574203?text=Hi,%20I%E2%80%99m%20looking%20for%20a%20new%20fulfillment%20partner.%0A%0AWe%E2%80%99re%20currently%20shipping%20approximately%20___%20orders%20per%20month%20to%20___%20(US%20/%20EU%20/%20Worldwide),%20and%20I%E2%80%99d%20like%20to%20discuss%20pricing%20and%20onboarding.";

  return (
    <div
      className={`fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="group relative inline-flex items-center justify-center gap-2 px-5 py-3.5 sm:px-6 sm:py-4 rounded-2xl text-white font-semibold text-sm sm:text-base overflow-hidden transition-all duration-500 hover:scale-[1.03] min-w-[140px] sm:min-w-[160px] min-h-[48px] sm:min-h-[56px]"
        style={{
          background: "linear-gradient(135deg, #5B2EFF 0%, #7C4DFF 50%, #9F7AEA 100%)",
          boxShadow: "0 0 40px rgba(91, 46, 255, 0.4), 0 8px 24px rgba(0, 0, 0, 0.3)",
        }}
        aria-label="Chat with Helium Fulfilment on WhatsApp"
      >
        {/* WhatsApp outline icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={18}
          height={18}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="relative z-10 shrink-0"
          aria-hidden="true"
        >
          <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
        </svg>
        <span className="relative z-10">Chat on WhatsApp</span>
        {/* Micro shimmer animation */}
        <div
          className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
          style={{
            background:
              "linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.2) 50%, transparent 100%)",
            backgroundSize: "200% 100%",
            animation: "shimmer 3s linear infinite",
          }}
        />
        {/* Subtle glow on hover */}
        <div
          className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
          style={{
            boxShadow: "0 0 60px rgba(91, 46, 255, 0.6), 0 12px 32px rgba(0, 0, 0, 0.4)",
          }}
        />
      </a>
    </div>
  );
}